import { useQuery } from "hooks/useQuery";
import { retrieveAnswers } from "services/index";

export const useQuestionnaireAnswers = ({ enabled }) => {
  const { isLoading, data, refetch } = useQuery({
    queryKey: ["questionnaireAnswers"],
    queryFn: async () => {
      const response = await retrieveAnswers();
      return response;
    },
    enabled,
  });

  return {
    isLoading,
    reviewQuestionChoice: data || {},
    strategies: data?.recommended_strategies?.strategies || [],
    hasAnswers: Array.isArray(data?.answers) && data?.answers.length > 0,
    refetchAnswers: refetch,
  };
};
